module.exports = __webpack_public_path__ + "img/3x.1f6424f.jpg";